/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';

import { getImageUrl } from '../../lib/getImageSize';

import VerifiedIcon from '../icons/VerifiedIcon';

import styles from '../../styles/partials/comment-avatar.module.css';

import defaultAvatar from '../../assets/img/avatar.svg';

interface CommentAvatarProps {
    author?: CommentAuthor | null;
    className?: string | null;
}

function CommentAvatar({ author, className = null }: CommentAvatarProps) {
    const { name, image, verified = false } = author;
    const thumbnailUrl = getImageUrl(image, 'thumbnail');
    return (
        <div
            className={classNames([styles.container, { [styles.isVerified]: verified }, className])}
        >
            <div className={styles.shape}>
                <img src={thumbnailUrl || defaultAvatar} alt={name} className={styles.image} />
            </div>
            {verified ? <VerifiedIcon className={styles.verified} /> : null}
        </div>
    );
}

export default CommentAvatar;
